<template>
  <div id="app" ref="fullscreenElement" min-width="520px"  >
    <title></title>
    <div class="app-header" :class="this.bgStyle">
      <el-row>
        <el-col :span="3" style="max-width: 100px">
          <img src="../assets/log/logo.png" id="img_log" alt />
        </el-col>
        <el-col :span="14">
          <span id="title_font"> {{ this.system_type_name }}</span>
        </el-col>
        <el-col :span="7" v-if="false">
          <div style="text-align: right">
            <el-button type="info" @click="kaidan" style="width: 120px" v-if="userType === 1">快捷开单</el-button>
            <el-button type="info" @click="jiesuan" style="width: 120px" v-if="userType === 1">结算服务</el-button>
            <el-button type="info" @click="toggleFullScreen" style="width: 80px">全屏3</el-button>
            <el-button type="info" @click="coll_menu" style="width: 80px">菜单</el-button>
            <el-button type="info" @click="logout" style="width: 80px">退出</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="app-content">
      <div class="app-wrap">
        <!-- 此处放置el-tabs代码 -->
        <div class="template-tabs">
          <el-tabs v-model="activeIndex" type="border-card" closable @tab-click="tabClick" v-if="options.length" @tab-remove="tabRemove">
            <el-tab-pane :key="item.name" v-for="item in options" :label="item.name" :name="item.route">
              <div class="content-wrap">
                <router-view :key="key"></router-view>
                <!-- v-wechat-title='$route.meta.title' -->
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="app-nav" v-if="iscollapse">
      <div class="app-nav-wrap">
        <el-menu background-color="#e3e9ef" text-color="#324057" active-text-color="#2d2d2d" :unique-opened="true" :collaZXpse-transition="false" :router="true" :default-active="activePath">
          <!-- 通过菜单组件activePath实现自动路由到指定地址 -->
          <el-submenu :index="item.menu_bianhao + ''" v-for="(item, index) in menuList" :key="index">
            <template slot="title">
              <i :class="iconsObj[item.menu_bianhao]"></i>
              <span>{{ item.menu_name }}</span>
            </template>
            <el-menu-item v-for="(subItem, index) in item.menu_children" :index="'/' + subItem.menu_path_p + '/' + subItem.menu_path_c" :key="index" @click="saveNavState('/' + subItem.menu_path_p + '/' + subItem.menu_path_c)">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span>{{ subItem.menu_name }}</span>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>

    <div class="foot" :class="this.bgStyle">
      <div class="foot_user">当前用户：{{ qiyeName }}::{{ userPhone }}</div>
      <div class="foot_copy">
        版权所有：<a href="http://www.pzeiot.com" style="" target="_blank">{{ copyright }}</a>
      </div>
    </div>
  </div>
</template>
<script>
// 使用方法：
// 调用这个函数并传入你想要全屏的元素即可。
// 如： requestFullScreen(document.documentElement); 将会使整个网页全屏。
export default {
  data() {
    return {
      copyright: '',
      system_type_name: '',
      date: new Date(),
      menuList: [],
      subMenu: [],
      iconsObj: {
        1: 'el-icon-s-custom',
        2: 'el-icon-share',
        3: 'el-icon-s-cooperation',
        4: 'el-icon-s-platform',
        5: 'el-icon-star-off',
        6: 'el-icon-s-goods',
        7: 'el-icon-fork-spoon',
        8: 'el-icon-s-order',
        9: 'el-icon-s-cooperation',
        10: 'el-icon-setting'
      },
      qiyeName: '',
      userPhone: '123',
      userType: 0,
      // 是否折叠
      iscollapse: true,
      activePath: ''
    }
  },
  created() {
    this.getMenu()
    this.activePath = window.sessionStorage.getItem('activePath')
    this.userPhone = window.sessionStorage.getItem('qiye_mob')
    this.copyright = window.sessionStorage.getItem('copyright')
    this.qiyeName = window.sessionStorage.getItem('qiye_name')
    this.bgStyle = 'bg_mob'
  },
  computed: {
    options() {
      return this.$store.state.options
    },
    activeIndex: {
      get() {
        return this.$store.state.activeIndex
      },
      set(val) {
        this.$store.commit('set_active_index', val)
      }
    },
    key() {
      return this.$router.name + new Date()
    }
  },
  watch: {
    // 路由拦截
    $route(to) {
      let flag = false
      for (const option of this.options) {
        if (option.name === to.name) {
          flag = true
          this.$store.commit('set_active_index', to.path)
          break
        }
      }
      // if (this.options.length === 0) {
      //     this.$store.commit('add_tabs', { route: 'welcome', name: '首页' });
      // }
      if (!flag) {
        this.$store.commit('add_tabs', { route: to.path, name: to.name })
        this.$store.commit('set_active_index', to.path)
      }
    }
  },
  mounted() {
    const _this = this // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.date = new Date() // 修改数据date
    }, 1000)

    // 刷新时以当前路由做为tab加入tabs
    if (this.$route.path !== '/' && this.$route.path.indexOf('userInfo') === -1) {
      //  this.$store.commit('add_tabs', { route: '/welcome', name: '首页' });
      this.$store.commit('add_tabs', {
        route: this.$route.path,
        name: this.$route.name
      })
      this.$store.commit('set_active_index', this.$route.path)
    } else {
      console.log(900, this.userType)
      if (this.userType === 1) {
        this.$store.commit('set_active_index', '/yysWelcome')
        this.$router.push('/yysWelcome')
      }
      if (this.userType === 2) {
        this.$store.commit('set_active_index', '/welcome')
        this.$router.push('/welcome')
      }
    }
  },
  methods: {
    kaidan() {
      this.$router.push('/shigong/kaidan')
    },
    jiesuan() {
      this.$router.push('/shigong/jiesuan')
    },
    toggleFullScreen() {
      if (document.fullscreenElement) {
        document.exitFullscreen() // 退出全屏模式
      } else {
        this.$refs.fullscreenElement.requestFullscreen() // 进入全屏模式
      }
    },
    // 此处有多次调用钩子函数的问题，需要调整
    // tab切换时，动态的切换路由
    tabClick(tab, event) {
      const path = this.activeIndex
      // 用户详情页的时候，对应了二级路由，需要拼接添加第二级路由
      // if (this.activeIndex === '/userInfo') {
      //   path = this.activeIndex + '/' + this.$store.state.userInfo.name;
      // }
      this.$router.push({ path: path })
    },
    tabRemove(targetName) {
      // 首页不可删除
      if (targetName === '/welcome') {
        return
      }
      this.$store.commit('delete_tabs', targetName)
      if (this.activeIndex === targetName) {
        // 设置当前激活的路由
        if (this.options && this.options.length >= 1) {
          this.$store.commit('set_active_index', this.options[this.options.length - 1].route)
          this.$router.push({ path: this.activeIndex })
        } else {
          this.$router.push({ path: '/' })
        }
      }
    },
    logout() {
      // if (window.sessionStorage.getItem('tokenUserType') === 1) this.$router.replace('../Admin');
      // if (window.sessionStorage.getItem('tokenUserType') === 2) this.$router.replace('../Login');

      //  console.log((window.sessionStorage.getItem('tokenUserType') === '2'))
      if (window.sessionStorage.getItem('tokenUserType') === '1') this.$router.replace('../Login')
      if (window.sessionStorage.getItem('tokenUserType') === '2') this.$router.replace('../Admin')
      this.$store.commit('delete_all')
      window.sessionStorage.clear()
    },

    async getMenu() {
      const { data: res } = await this.$http.get('get_api', {
        params: {
          C_type: 'getMenu',
          token: window.sessionStorage.getItem('token') // 递交数据，必须携带token
        }
      })
      //  console.log(JSON.parse(res.data)[0])
      if (JSON.parse(res.data)[0].status === 200) {
        this.menuList = JSON.parse(res.data)[0].menu_data
      } else {
        this.$message('权限不足!')
        if (this.userType === 1) this.$router.push('../Login')
        if (this.userType === 2) this.$router.push('../Admin')
      }
      // console.log(res.menu_children)
      //  this.subMenu = JSON.parse(res.children)
    },
    coll_menu() {
      this.iscollapse = !this.iscollapse
    },
    saveNavState(activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>
<style lang="less">
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#img_log {
  width: 180px;
}

#title_font {
  font-size: 1.6em;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  display: flex;
  flex-flow: column;
  overflow: hidden;

  .app-header {
    color: #fff;
    flex: 0 0 60px;
    height: 60px;
    line-height: 60px;
    padding: 0 20px;

    .title {
      font-size: 24px;
    }
  }

  .app-content {
    // flex: 1;
    // display: flex;
    // flex-flow: column;

    .app-nav {
      flex: 0 0 300px;
      background: #eff2f7;
    }

    .app-nav_suo {
      flex: 0 0 60px;
      background: #eff2f7;
    }

    .app-wrap {
      // flex: 1;
      height: 100vh;
      padding: 10px 20px;
      overflow-y: scroll;
      overflow-x: none;
    }

    .content-wrap {
      height: 100vh;
      overflow-y: auto;
      border-top: none;
      padding: 0 20px;
    }
  }
}

.foot {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  width: 100%;
  padding: 5px;
  text-align: center;
  bottom: 0px;
  position: fixed;
}
.bg_mob {
  background: #000;
}
.bg_admin {
  background-color: #324057;
}

.bg_yys {
  background-color: #071718;
}

.foot_copy {
  width: 100%;
  color: #fff;
  text-align: center;
  font-size: small;
}

.foot_user {
  color: #fff;
  width: 400px;
  font-size: 15px;
  text-align: left;
}

a:link {
  color: #ffffff;
  text-decoration: none;
}

a:visited {
  color: #ffffff;
  text-decoration: none;
}

a:hover {
  color: #ffffff;
  text-decoration: none;
}

a:active {
  color: #ffffff;
  text-decoration: none;
}
</style>
